import { connect } from 'react-redux';
import { toggleSubmitMenu } from '../../redux/actions';
const mapDispatchToProps = {
    toggleSubmitMenu
};
export default connect(null, mapDispatchToProps);

//# sourceMappingURL=SubmitMenu.container.js.map